import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMemo } from 'react'
import { faComments, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { logout } from '../../auth'
import { MOBILE_NAVIGATION_SECTIONS } from '../../app/navigationConfig'
import usePermissions from '../../hooks/usePermissions'

const MobileSidebar = ({ setMessages, onClose }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { hasPermission } = usePermissions()

  const filteredSections = useMemo(() => {
    return MOBILE_NAVIGATION_SECTIONS
      .map((section) => ({
        ...section,
        items: section.items.filter(
          (item) => !item.requiredPermission || hasPermission(item.requiredPermission)
        )
      }))
      .filter((section) => section.items.length > 0)
  }, [hasPermission])

  const MobileNavItem = ({ item, isActive }) => {
    return (
      <div
        className={`flex items-center px-4 py-3 rounded-xl cursor-pointer transition-all duration-300 ${
          isActive
            ? 'bg-gradient-to-r from-light_coral to-primary text-white shadow-lg transform scale-105'
            : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dk-hover hover:text-gray-900 dark:hover:text-white hover:shadow-md hover:transform hover:scale-102'
        }`}
        onClick={() => {
          if (location.pathname === item.path) {
            navigate('/lobbies')
          } else {
            navigate(item.path)
          }
          onClose()
        }}
      >
        <FontAwesomeIcon icon={item.icon} className='w-5 h-5 mr-3' />
        <span className='text-sm font-medium'>{item.name}</span>
      </div>
    )
  }

  return (
    <div className='flex flex-col py-6 px-4 h-full'>
      {/* Mobile Header */}
      <div className='flex items-center justify-between mb-8'>
        <div className='flex items-center'>
          <img src={require('../../assets/icons/logo.png')} alt='logo' className='w-8 h-8' />
          <span className={`ml-3 text-lg font-semibold text-gray-800 dark:text-gray-100`}>Admin Panel</span>
        </div>
        <button
          onClick={onClose}
          className='p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-dk-hover transition-all duration-300'
        >
          <svg
            className='w-6 h-6 text-gray-600 dark:text-gray-300'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M6 18L18 6M6 6l12 12'
            />
          </svg>
        </button>
      </div>

      {/* Chat Button */}
      {hasPermission('channels') && <div className='mb-8'>
        <div
          className='w-full bg-gradient-to-r from-primary to-light_coral hover:from-light_coral hover:to-primary text-white rounded-xl py-4 px-4 cursor-pointer transition-all duration-300 flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-105'
          onClick={() => {
            setMessages(true)
            onClose()
          }}
        >
          <FontAwesomeIcon icon={faComments} className='w-5 h-5 mr-2' />
          <span className='font-semibold'>CHAT</span>
        </div>
      </div>}

      {/* Navigation Sections */}
      <div className='flex-1 overflow-y-auto'>
        {filteredSections.map((section, index) => (
          <div key={index} className='mb-6'>
            <h3 className='px-2 py-2 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-3'>
              {section.title}
            </h3>
            <div className='space-y-2'>
              {section.items.map((item, itemIndex) => (
                <MobileNavItem
                  key={itemIndex}
                  item={item}
                  isActive={location.pathname === item.path}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Logout Button */}
      <div className='mt-auto pt-4'>
        <div
          className='w-full flex items-center justify-center px-4 py-3 text-gray-500 dark:text-gray-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-600 dark:hover:text-red-400 rounded-xl cursor-pointer transition-all duration-300 hover:shadow-md'
          onClick={() => {
            logout({ returnTo: window.origin })
            onClose()
          }}
        >
          <FontAwesomeIcon icon={faSignOutAlt} className='w-5 h-5 mr-3' />
          <span className='font-medium'>Cerrar sesión</span>
        </div>
      </div>
    </div>
  )
}

export default MobileSidebar
